import { withChartLayout } from 'components/common';
import Impressions from 'components/features/chart/provider-chart/history-physical/impressions/Impressions';

const ImpressionsPage = withChartLayout('Impressions')(Impressions);
export default ImpressionsPage;
